import { MapPinned } from "lucide-react";
import { useEffect, useState } from "react";
import { useSession } from "../App.js";
import { lastVault, touchVault } from "../lib/recentVault.js";
import { TimelineView } from "./Timeline.js";

/** Top-level, always-reachable timeline: no vault picking through Dashboard first. Defaults to the
 *  single vault when there's only one, otherwise the most recently used. */
export function TimelineHome() {
  const { me } = useSession();
  const [vaultId, setVaultId] = useState("");

  useEffect(() => {
    if (!me || vaultId || me.vaults.length === 0) return;
    const recent = lastVault(me.user.id);
    const stillMine = recent && me.vaults.some((v) => v.id === recent);
    setVaultId(stillMine ? recent : me.vaults[0]!.id);
  }, [me, vaultId]);

  if (!me) return null;
  if (me.vaults.length === 0) {
    return (
      <div className="card empty">
        <MapPinned size={28} className="icon muted" style={{ marginBottom: 8 }} />
        <p className="muted">No vaults yet. Once you have one, its timeline shows up here.</p>
      </div>
    );
  }

  return (
    <div>
      {me.vaults.length > 1 && (
        <div className="row" style={{ marginBottom: 12 }}>
          <select
            style={{ maxWidth: 280 }}
            value={vaultId}
            onChange={(e) => {
              setVaultId(e.target.value);
              touchVault(me.user.id, e.target.value);
            }}
          >
            {me.vaults.map((v) => (
              <option key={v.id} value={v.id}>
                {v.name}
              </option>
            ))}
          </select>
        </div>
      )}
      {vaultId && <TimelineView vaultId={vaultId} />}
    </div>
  );
}
